module.exports = __webpack_public_path__ + "img/cards1_front125.48ed4ef1.png";